import apiClient from '@/services/axios'

export const post = async (request) => {
    const response = await apiClient.post('/mediaspace/targeted-users-count', request)
    return response.data
} 